import React from 'react'

const Jva_ref = () => {
    return (
        <div className='container'>
            <article class="content post-509092 post type-post status-publish format-standard hentry category-java"
  id="post-509092">
  <h1>Reference Variable in Java</h1>

  <div class="text">
    <p >Before We Started with the <strong>Reference variable</strong> we should know about
      the following facts.</p>
    <p ><strong>1. </strong>When we create an object<strong> </strong>(instance) of class then
      space is reserved in heap memory. Let’s understand with the help of an example.</p>
    <blockquote>
      <p >Demo D1 = new Demo();</p>
    </blockquote>
    <p></p>
    <p >Now, The space in the heap Memory is created but the question is <strong>how to access
        that space?</strong>. &nbsp;</p><br/>
   
    
    <p >Then, We create a Pointing element or simply called <strong>Reference
        variable</strong> which simply points out the Object(the created space in a Heap Memory). &nbsp;</p>
    <p></p>
    <p ><strong>Understanding Reference variable&nbsp;</strong></p>
    <p ><strong>1.</strong> Reference variable is used to point object/values.</p>
    <p ><strong>2. </strong>Classes, interfaces, arrays, enumerations, and, annotations are
      reference types in Java. Reference variables hold the objects/values of reference types in Java.</p>
    <p ><strong>3.</strong> Reference variable can also store <strong>null</strong> value. By
      default, if no object is passed to a reference variable then it will store a null value.</p>
    <p ><strong>4. </strong>You can access object members using a reference variable using
      <strong>dot </strong>syntax.</p>
    <blockquote className='containers'>
      <p >&lt;reference variable name &gt;.&lt;instance &nbsp;variable_name / method_name&gt;
      </p><br/>
     
    </blockquote> 
    <p ><strong>Example:</strong></p>
    <div class="responsive-tabs-wrapper">
      <div class="responsive-tabs responsive-tabs--enabled">
       
        
        <div class="tabcontent responsive-tabs__panel responsive-tabs__panel--active" aria-hidden="false"
          role="tabpanel" aria-labelledby="tablist1-tab1" id="tablist1-panel1">
         
            <div class="code-containers">
              <div id="highlighter_28998" class="syntaxhighlighter nogutter">
                
                      <td class="code">
                        <div class="containers">
                          <div class="line number1 index0 alt2"><code
                              class="comment">// Java program to demonstrate reference</code></div>
                          <div class="line number2 index1 alt1"><code class="comment">// variable in java</code></div>
                          <div class="line number3 index2 alt2">&nbsp;</div>
                          <div class="line number4 index3 alt1"><code class="keywords">import</code> <code
                              class="plain">java.io.*;</code></div>
                          <div class="line number5 index4 alt2">&nbsp;</div>
                          <div class="line number6 index5 alt1"><code class="keywords">class</code> <code
                              class="plain">Demo &#123;</code></div>
                          <div class="line number7 index6 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">int</code>
                            <code class="plain">x = </code><code class="value">10</code><code class="plain">;</code>
                          </div>
                          <div class="line number8 index7 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">int</code>
                            <code class="plain">display()</code></div>
                          <div class="line number9 index8 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code></div>
                          <div class="line number10 index9 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">System.out.println(</code><code class="string">"x = "</code> <code
                              class="plain">+ x);</code></div>
                          <div class="line number11 index10 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="keywords">return</code> <code class="value">0</code><code class="plain">;</code>
                          </div>
                          <div class="line number12 index11 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code></div>
                          <div class="line number13 index12 alt2"><code class="plain">&#125;</code></div>
                          <div class="line number14 index13 alt1">&nbsp;</div>
                          <div class="line number15 index14 alt2"><code class="keywords">class</code> <code
                              class="plain">Main &#123;</code></div>
                          <div class="line number16 index15 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="keywords">public</code> <code class="keywords">static</code> <code
                              class="keywords">void</code> <code class="plain">main(String[] args)</code></div>
                          <div class="line number17 index16 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code></div>
                          <div class="line number18 index17 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">Demo D1 = </code><code class="keywords">new</code> <code
                              class="plain">Demo(); </code><code class="comment">// point 1</code></div>
                          <div class="line number19 index18 alt2">&nbsp;</div>
                          <div class="line number20 index19 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">System.out.println(D1); </code><code class="comment">// point 2</code>
                          </div>
                          <div class="line number21 index20 alt2">&nbsp;</div>
                          <div class="line number22 index21 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">System.out.println(D1.display()); </code><code
                              class="comment">// point 3</code></div>
                          <div class="line number23 index22 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code></div>
                          <div class="line number24 index23 alt1"><code class="plain">&#125;</code></div>
                        </div>
                      </td>
                    
              </div>
            </div>
           
          </div>
          
           
          </div>
        </div>
      </div>
    
    <p>&nbsp;<br/>&nbsp;</p>
    <div class="output"><strong>Output</strong>
      <pre>Demo@214c265e <br />
  x = 10
  0</pre>
    </div>
    <p>&nbsp;</p>
    <p ><strong>Let us see what is actually happening step by step.</strong></p>
    <p>&nbsp;</p>
    <p ><strong>1.</strong> When we create an object of demo class <strong>new
        DEMO();</strong>, the default constructor is called and returns a reference of the object, and simply this
      reference will be stored to the reference variable <strong>D1</strong> (As we know that associativity is
      Right-hand side to left-hand side).</p>
    <p>&nbsp;</p>
    <p ><strong>2.</strong> The value of a reference variable is a reference. When we attempt
      to print the value of a reference variable, the output contains the type of the variable and the hash code created
      for it by Java: the string <strong>Demo@214c265e</strong> tells us that the given variable is of type Name and its
      hexadecimal format of hash code is 214c265e.</p>
    <p>&nbsp;</p><br/>
    <div id="AP_G4GR_6"></div>
    <div id="82d2079a-8120-480f-9fc7-5cda825d56e7" class="_ap_apex_ad">
     
    </div><br/>
    <p ><strong>3. </strong>At this point we will access the methods
      <strong>display()</strong> of the class demo using our custom reference variable that we created.</p>
    <p>&nbsp;</p>
    <blockquote>
      <p ><strong>BINDING UP</strong> : The constructor call returns a value that is a
        reference to the newly-created object. The equality sign tells the program that the value of the right-hand side
        expression is to be copied as the value of the variable on the left-hand side. The reference to the
        newly-created object, returned by the constructor call, is copied as the value of the variable.</p>
    </blockquote>
    <p>&nbsp;</p>
    <div class="responsive-tabs-wrapper">
      <div class="responsive-tabs responsive-tabs--enabled">
        
        
        <div class="tabcontent responsive-tabs__panel responsive-tabs__panel--active" aria-hidden="false"
          role="tabpanel" aria-labelledby="tablist2-tab1" id="tablist2-panel1">
         
            <div class="code-containers">
              <div id="highlighter_358041" class="syntaxhighlighter nogutter">
                
                      <td class="code">
                        <div class="containers">
                          <div class="line number1 index0 alt2"><code class="keywords">import</code> <code
                              class="plain">java.io.*;</code></div>
                          <div class="line number2 index1 alt1"><code class="keywords">class</code> <code
                              class="plain">Demo &#123;</code></div>
                          <div class="line number3 index2 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">int</code>
                            <code class="plain">x = </code><code class="value">10</code><code class="plain">;</code>
                          </div>
                          <div class="line number4 index3 alt1">&nbsp;</div>
                          <div class="line number5 index4 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">int</code>
                            <code class="plain">display()</code></div>
                          <div class="line number6 index5 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code></div>
                          <div class="line number7 index6 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">System.out.println(</code><code class="string">"x = "</code> <code
                              class="plain">+ x);</code></div>
                          <div class="line number8 index7 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="keywords">return</code> <code class="value">0</code><code class="plain">;</code>
                          </div>
                          <div class="line number9 index8 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code></div>
                          <div class="line number10 index9 alt1"><code class="plain">&#125;</code></div>
                          <div class="line number11 index10 alt2">&nbsp;</div>
                          <div class="line number12 index11 alt1"><code class="keywords">class</code> <code
                              class="plain">Main &#123;</code></div>
                          <div class="line number13 index12 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="keywords">public</code> <code class="keywords">static</code> <code
                              class="keywords">void</code> <code class="plain">main(String[] args)</code></div>
                          <div class="line number14 index13 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code></div>
                          <div class="line number15 index14 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// create instance</code></div>
                          <div class="line number16 index15 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">Demo D1 = </code><code class="keywords">new</code> <code
                              class="plain">Demo();</code></div>
                          <div class="line number17 index16 alt2">&nbsp;</div>
                          <div class="line number18 index17 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// accessing instance(object) variable</code></div>
                          <div class="line number19 index18 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">System.out.println(D1.x);</code></div>
                          <div class="line number20 index19 alt1">&nbsp;</div>
                          <div class="line number21 index20 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// point 3</code></div>
                          <div class="line number22 index21 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// accessing instance(object) method</code></div>
                          <div class="line number23 index22 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">D1.display();</code></div>
                          <div class="line number24 index23 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code></div>
                          <div class="line number25 index24 alt2"><code class="plain">&#125;</code></div>
                        </div>
                      </td>
                    
              </div>
            </div>
           
          </div>
          
           
          </div>
        </div>
      
    <p>&nbsp;<br/>&nbsp;</p>
    <div class="output"><strong>Output</strong>
      <pre>10 <br />
  x = 10</pre>
    </div>
    <p>&nbsp;</p>
    <p></p>
    <p>&nbsp;</p>
    <div class="responsive-tabs-wrapper">
      <div class="responsive-tabs responsive-tabs--enabled">
        <ul class="responsive-tabs__list" role="tablist">
          <li class="responsive-tabs__list__item responsive-tabs__list__item--active" id="tablist3-tab1"
            aria-controls="tablist3-panel1" role="tab" tabindex="0">Java</li>
        </ul>
        
        <div class="tabcontent responsive-tabs__panel responsive-tabs__panel--active" aria-hidden="false"
          role="tabpanel" aria-labelledby="tablist3-tab1" id="tablist3-panel1">
         
            <div class="code-containers">
              <div id="highlighter_926776" class="syntaxhighlighter nogutter">
                
                      <td class="code">
                        <div class="containers">
                          <div class="line number1 index0 alt2"><code
                              class="comment">// Accessing instance methods</code></div>
                          <div class="line number2 index1 alt1">&nbsp;</div>
                          <div class="line number3 index2 alt2"><code class="keywords">import</code> <code
                              class="plain">java.io.*;</code></div>
                          <div class="line number4 index3 alt1"><code class="keywords">class</code> <code
                              class="plain">Demo &#123;</code></div>
                          <div class="line number5 index4 alt2"><code class="undefined spaces">&nbsp;&nbsp;</code>&nbsp;
                          </div>
                          <div class="line number6 index5 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">int</code>
                            <code class="plain">x = </code><code class="value">10</code><code class="plain">;</code>
                          </div>
                          <div class="line number7 index6 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">int</code>
                            <code class="plain">display()</code></div>
                          <div class="line number8 index7 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code></div>
                          <div class="line number9 index8 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">System.out.println(</code><code class="string">"x = "</code> <code
                              class="plain">+ x);</code></div>
                          <div class="line number10 index9 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="keywords">return</code> <code class="value">0</code><code class="plain">;</code>
                          </div>
                          <div class="line number11 index10 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code></div>
                          <div class="line number12 index11 alt1"><code class="plain">&#125;</code></div>
                          <div class="line number13 index12 alt2"><code class="keywords">class</code> <code
                              class="plain">Main &#123;</code></div>
                          <div class="line number14 index13 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="keywords">public</code> <code class="keywords">static</code> <code
                              class="keywords">void</code> <code class="plain">main(String[] args)</code></div>
                          <div class="line number15 index14 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code></div>
                          <div class="line number16 index15 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// create instances</code></div>
                          <div class="line number17 index16 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">Demo D1 = </code><code class="keywords">new</code> <code
                              class="plain">Demo();</code></div>
                          <div class="line number18 index17 alt1">&nbsp;</div>
                          <div class="line number19 index18 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">Demo M1 = </code><code class="keywords">new</code> <code
                              class="plain">Demo();</code></div>
                          <div class="line number20 index19 alt1">&nbsp;</div>
                          <div class="line number21 index20 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">Demo Q1 = </code><code class="keywords">new</code> <code
                              class="plain">Demo();</code></div>
                          <div class="line number22 index21 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code></div>
                          <div class="line number23 index22 alt2"><code class="plain">&#125;</code></div>
                        </div>
                      </td>
                    
              </div>
            </div>
           
          </div>
          
           
          </div>
          <p></p>
        </div>
   <br/><br/>
    <div class="responsive-tabs-wrapper">
      <div class="responsive-tabs responsive-tabs--enabled">
        
        
        <div class="tabcontent responsive-tabs__panel responsive-tabs__panel--active" aria-hidden="false"
          role="tabpanel" aria-labelledby="tablist4-tab1" id="tablist4-panel1">
         
            <div class="code-containers">
              <div id="highlighter_466367" class="syntaxhighlighter nogutter">
                
                      <td class="code">
                        <div class="containers">
                          <div class="line number1 index0 alt2"><code
                              class="comment">// Pointing to same instance memory</code></div>
                          <div class="line number2 index1 alt1">&nbsp;</div>
                          <div class="line number3 index2 alt2"><code class="keywords">import</code> <code
                              class="plain">java.io.*;</code></div>
                          <div class="line number4 index3 alt1"><code class="keywords">class</code> <code
                              class="plain">Demo &#123;</code></div>
                          <div class="line number5 index4 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">int</code>
                            <code class="plain">x = </code><code class="value">10</code><code class="plain">;</code>
                          </div>
                          <div class="line number6 index5 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">int</code>
                            <code class="plain">display()</code></div>
                          <div class="line number7 index6 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code></div>
                          <div class="line number8 index7 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">System.out.println(</code><code class="string">"x = "</code> <code
                              class="plain">+ x);</code></div>
                          <div class="line number9 index8 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="keywords">return</code> <code class="value">0</code><code class="plain">;</code>
                          </div>
                          <div class="line number10 index9 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code></div>
                          <div class="line number11 index10 alt2"><code class="plain">&#125;</code></div>
                          <div class="line number12 index11 alt1"><code class="keywords">class</code> <code
                              class="plain">Main &#123;</code></div>
                          <div class="line number13 index12 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="keywords">public</code> <code class="keywords">static</code> <code
                              class="keywords">void</code> <code class="plain">main(String[] args)</code></div>
                          <div class="line number14 index13 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code></div>
                          <div class="line number15 index14 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// create instance</code></div>
                          <div class="line number16 index15 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">Demo D1 = </code><code class="keywords">new</code> <code
                              class="plain">Demo();</code></div>
                          <div class="line number17 index16 alt2">&nbsp;</div>
                          <div class="line number18 index17 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// point to same reference</code></div>
                          <div class="line number19 index18 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">Demo G1 = D1;</code></div>
                          <div class="line number20 index19 alt1">&nbsp;</div>
                          <div class="line number21 index20 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">Demo M1 = </code><code class="keywords">new</code> <code
                              class="plain">Demo();</code></div>
                          <div class="line number22 index21 alt1">&nbsp;</div>
                          <div class="line number23 index22 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">Demo Q1 = M1;</code></div>
                          <div class="line number24 index23 alt1">&nbsp;</div>
                          <div class="line number25 index24 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// updating the value of x using G!</code></div>
                          <div class="line number26 index25 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// reference variable</code></div>
                          <div class="line number27 index26 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">G1.x = </code><code class="value">25</code><code class="plain">;</code>
                          </div>
                          <div class="line number28 index27 alt1">&nbsp;</div>
                          <div class="line number29 index28 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">System.out.println(G1.x); </code><code class="comment">// Point 1</code>
                          </div>
                          <div class="line number30 index29 alt1">&nbsp;</div>
                          <div class="line number31 index30 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">System.out.println(D1.x); </code><code class="comment">// Point 2</code>
                          </div>
                          <div class="line number32 index31 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code></div>
                          <div class="line number33 index32 alt2"><code class="plain">&#125;</code></div>
                        </div>
                      </td>
                    
              </div>
            </div>
           
          </div>
          
           
          </div>
        </div>
     
    <p>&nbsp;<br/>&nbsp;</p>
    <div class="output"><strong>Output</strong>
      <pre>25 <br />
  25</pre>
    </div>
    <p>&nbsp;</p>
    <p></p>
    <blockquote>
      <p ><strong>Note:</strong></p>
      <p >Here we pass G1 and Q1 reference variable point out the same object
        respectively.&lt;br&gt; Secondly **At Point 1** we try to get the value of the object with G1 reference variable
        which shows it as **25** and **At Point 2**we try to get the value of an object with D1 reference variable which
        shows it as **25** as well “” This will prove that the modification in the object can be done by using any
        reference variable but the condition is it should hold the same reference. &nbsp;</p>
    </blockquote>
    <h3 >More on Reference Variable</h3>
    <p ><strong>1. Reference Variable as Method Parameters:</strong></p>
    <p>&nbsp;</p>
    <p >As the value of a primitive variable is directly stored in the variable, whereas the
      value of a reference variable holds a reference to an object. We also mentioned that assigning a value with the
      equality sign copies the value (possibly of some variable) on the right-hand side and stores it as the value of
      the left-hand-side variable. A similar kind of copying occurs during a method call. Regardless of whether the
      variable is primitive or reference type, a copy of value passed to the method’s argument and copied to that
      argument.</p>
    <p>&nbsp;</p>
    <blockquote>
      <p ><strong>Note: </strong>Java only supports pass by value.</p>
    </blockquote>
    <p >But we know that the reference variable holds the reference of an instance(OBJECT) so
      a copy of reference passed to the method’s argument. &nbsp;</p>
    <p>&nbsp;</p>
    <p ><strong>Example:</strong></p>
    <p>&nbsp;</p>
    <div class="responsive-tabs-wrapper">
      <div class="responsive-tabs responsive-tabs--enabled">
        
        
        <div class="tabcontent responsive-tabs__panel responsive-tabs__panel--active" aria-hidden="false"
          role="tabpanel" aria-labelledby="tablist5-tab1" id="tablist5-panel1">
         
            <div class="code-containers">
              <div id="highlighter_43896" class="syntaxhighlighter nogutter">
                
                      <td class="code">
                        <div class="containers">
                          <div class="line number1 index0 alt2"><code
                              class="comment">// Pass by reference and value</code></div>
                          <div class="line number2 index1 alt1">&nbsp;</div>
                          <div class="line number3 index2 alt2"><code class="keywords">import</code> <code
                              class="plain">java.io.*;</code></div>
                          <div class="line number4 index3 alt1"><code class="keywords">class</code> <code
                              class="plain">Demo &#123;</code></div>
                          <div class="line number5 index4 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">int</code>
                            <code class="plain">x = </code><code class="value">10</code><code class="plain">;</code>
                          </div>
                          <div class="line number6 index5 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">int</code>
                            <code class="plain">y = </code><code class="value">20</code><code class="plain">;</code>
                          </div>
                          <div class="line number7 index6 alt2">&nbsp;</div>
                          <div class="line number8 index7 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">int</code>
                            <code class="plain">display(Demo A, Demo B)</code></div>
                          <div class="line number9 index8 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code></div>
                          <div class="line number10 index9 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">//&nbsp; Updating value using argument</code></div>
                          <div class="line number11 index10 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">A.x = </code><code class="value">95</code><code class="plain">;</code></div>
                          <div class="line number12 index11 alt1">&nbsp;</div>
                          <div class="line number13 index12 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">System.out.println(</code><code class="string">"x = "</code> <code
                              class="plain">+ x);</code></div>
                          <div class="line number14 index13 alt1">&nbsp;</div>
                          <div class="line number15 index14 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">System.out.println(</code><code class="string">"y = "</code> <code
                              class="plain">+ y);</code></div>
                          <div class="line number16 index15 alt1">&nbsp;</div>
                          <div class="line number17 index16 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="keywords">return</code> <code class="value">0</code><code class="plain">;</code>
                          </div>
                          <div class="line number18 index17 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code></div>
                          <div class="line number19 index18 alt2"><code class="plain">&#125;</code></div>
                          <div class="line number20 index19 alt1"><code class="keywords">class</code> <code
                              class="plain">Main &#123;</code></div>
                          <div class="line number21 index20 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="keywords">public</code> <code class="keywords">static</code> <code
                              class="keywords">void</code> <code class="plain">main(String[] args)</code></div>
                          <div class="line number22 index21 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code></div>
                          <div class="line number23 index22 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">Demo C = </code><code class="keywords">new</code> <code
                              class="plain">Demo();</code></div>
                          <div class="line number24 index23 alt1">&nbsp;</div>
                          <div class="line number25 index24 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">Demo D = </code><code class="keywords">new</code> <code
                              class="plain">Demo();</code></div>
                          <div class="line number26 index25 alt1">&nbsp;</div>
                          <div class="line number27 index26 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// updating value using primary reference</code></div>
                          <div class="line number28 index27 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// variable</code></div>
                          <div class="line number29 index28 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">D.y = </code><code class="value">55</code><code class="plain">;</code></div>
                          <div class="line number30 index29 alt1">&nbsp;</div>
                          <div class="line number31 index30 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">C.display(C, D); </code><code class="comment">// POINT 1</code></div>
                          <div class="line number32 index31 alt1">&nbsp;</div>
                          <div class="line number33 index32 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">D.display(C, D); </code><code class="comment">// POINT 2</code></div>
                          <div class="line number34 index33 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code></div>
                          <div class="line number35 index34 alt2"><code class="plain">&#125;</code></div>
                        </div>
                      </td>
                    
              </div>
            </div>
           
          </div>
          
           
          </div>
        </div>
     
    <p>&nbsp;<br/>&nbsp;</p>
    <div class="output"><strong>Output</strong>
      <pre>x = 95 <br />
  y = 20 <br />
  x = 10 <br />
  y = 55</pre>
    </div>
    <p>&nbsp;</p>
    <p ><strong>SCENE 1 :</strong></p>
    <p>&nbsp;</p>
    <p></p>
    <p ><strong>SCENE 2:</strong></p>
    <p>&nbsp;</p>
    <p></p>
    <p >Now, What is going on here, when we pass the reference to the method it will copy to
      the reference variable defined in the method signature and After that, they also have access to the object
      members. Here, We defined two instances named <strong>C and D</strong>. Afterwards we pass C and D to the method
      which further gives reference to <strong>A and B</strong></p>
    <p>&nbsp;</p>
    <p ><strong>At Point 1: </strong>A will update the value of x from 10 to 95, hence
      C.display() will show 95 20 but in another object D we update the value of x through D only from y =20 to 55,
      hence D, display() will show 10 and 55.</p>
    <p>&nbsp;</p>
    <blockquote>
      <p ><strong>Note: </strong>Any Object Updation will not affect the other object’s
        member.</p>
    </blockquote>
    <p ><strong>2. What if we swap the reference variables with the help of the Swap
        Method?</strong></p>
    <p>&nbsp;</p>
    <p >The fact is if we try to swap the reference variable, then they just swap their
      Pointing element there is no effect on the address of reference variable and object(Instance) Space. Let’s
      Understand It with the help of an example:<br/>&nbsp;</p>
    <p>&nbsp;</p>
    <div class="responsive-tabs-wrapper">
      <div class="responsive-tabs responsive-tabs--enabled">
       
        
        <div class="tabcontent responsive-tabs__panel responsive-tabs__panel--active" aria-hidden="false"
          role="tabpanel" aria-labelledby="tablist6-tab1" id="tablist6-panel1">
         
            <div class="code-containers">
              <div id="highlighter_199391" class="syntaxhighlighter nogutter">
                
                      <td class="code">
                        <div class="containers">
                          <div class="line number1 index0 alt2"><code
                              class="comment">// Swapping object references</code></div>
                          <div class="line number2 index1 alt1">&nbsp;</div>
                          <div class="line number3 index2 alt2"><code class="keywords">import</code> <code
                              class="plain">java.io.*;</code></div>
                          <div class="line number4 index3 alt1"><code class="keywords">class</code> <code
                              class="plain">Demo &#123;</code></div>
                          <div class="line number5 index4 alt2">&nbsp;</div>
                          <div class="line number6 index5 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// Swapping Method</code></div>
                          <div class="line number7 index6 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">int</code>
                            <code class="plain">Swap(Demo A, Demo B)</code></div>
                          <div class="line number8 index7 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code></div>
                          <div class="line number9 index8 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">Demo temp = A;</code></div>
                          <div class="line number10 index9 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">A = B;</code></div>
                          <div class="line number11 index10 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">B = temp;</code></div>
                          <div class="line number12 index11 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="keywords">return</code> <code class="value">0</code><code class="plain">;</code>
                          </div>
                          <div class="line number13 index12 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code></div>
                          <div class="line number14 index13 alt1"><code class="plain">&#125;</code></div>
                          <div class="line number15 index14 alt2"><code class="keywords">class</code> <code
                              class="plain">Main &#123;</code></div>
                          <div class="line number16 index15 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="keywords">public</code> <code class="keywords">static</code> <code
                              class="keywords">void</code> <code class="plain">main(String[] args)</code></div>
                          <div class="line number17 index16 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code></div>
                          <div class="line number18 index17 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">Demo C = </code><code class="keywords">new</code> <code
                              class="plain">Demo();</code></div>
                          <div class="line number19 index18 alt2">&nbsp;</div>
                          <div class="line number20 index19 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">Demo D = </code><code class="keywords">new</code> <code
                              class="plain">Demo();</code></div>
                          <div class="line number21 index20 alt2">&nbsp;</div>
                          <div class="line number22 index21 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// Passing C and reference variables</code></div>
                          <div class="line number23 index22 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="comment">// to Swap method</code></div>
                          <div class="line number24 index23 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">C.Swap(C, D);</code></div>
                          <div class="line number25 index24 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code></div>
                          <div class="line number26 index25 alt1"><code class="plain">&#125;</code></div>
                        </div>
                      </td>
                    
              </div>
            </div>
           
          </div>
          
           
          </div>
        </div>
     
    <blockquote>
      <p >Here we created, two instances of demo class and passes it to swap method, further
        those C and D will copy their references to A and B respectively.Before swapping A point to C’s(Object) and B
        point to D’s(Object). After we perform swapping on A and B, A will now point D’s(Object) and B will Point C’s
        Object. As described in the figure.</p>
    </blockquote>
    <p></p>
    <blockquote>
      <p ><strong>&nbsp;Note: </strong>There is no swapping between Variables, They only
        change their References.</p>
    </blockquote>
    <p ><strong>3. What if we pass arrays to the method will it be able to update the Actual
        Array’s values, even we know that a copy of the array is a pass to the formal Array?</strong></p>
    <p >The answer is <strong>YES, </strong>the values will be updated by Formal parameter,
      The Fact is, When we create an Array, a memory is assigned to the array of the desired size, and it returns the
      reference of the first array’s element that is the base address that will store to the Formal Array(Method
      argument). As we learned earlier every pointing reference variable can change or update the object.</p>
    <p></p>
    <p ><strong>Example:</strong></p>
    <div class="responsive-tabs-wrapper">
      <div class="responsive-tabs responsive-tabs--enabled">
        
        
        <div class="tabcontent responsive-tabs__panel responsive-tabs__panel--active" aria-hidden="false"
          role="tabpanel" aria-labelledby="tablist7-tab1" id="tablist7-panel1">
         
            <div class="code-containers">
              <div id="highlighter_470822" class="syntaxhighlighter nogutter">
                
                      <td class="code">
                        <div class="containers">
                          <div class="line number1 index0 alt2"><code class="keywords">import</code> <code
                              class="plain">java.io.*;</code></div>
                          <div class="line number2 index1 alt1"><code class="keywords">class</code> <code
                              class="plain">Demo &#123;</code></div>
                          <div class="line number3 index2 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">int</code>
                            <code class="plain">arrayUpdate(</code><code class="keywords">int</code><code
                              class="plain">[] formalArray)</code></div>
                          <div class="line number4 index3 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code></div>
                          <div class="line number5 index4 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">formalArray[</code><code class="value">2</code><code
                              class="plain">] = </code><code class="value">99</code><code class="plain">;</code></div>
                          <div class="line number6 index5 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">formalArray[</code><code class="value">4</code><code
                              class="plain">] = </code><code class="value">77</code><code class="plain">;</code></div>
                          <div class="line number7 index6 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="keywords">return</code> <code class="value">0</code><code class="plain">;</code>
                          </div>
                          <div class="line number8 index7 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code></div>
                          <div class="line number9 index8 alt2"><code class="plain">&#125;</code></div>
                          <div class="line number10 index9 alt1"><code class="keywords">class</code> <code
                              class="plain">Main &#123;</code></div>
                          <div class="line number11 index10 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="keywords">public</code> <code class="keywords">static</code> <code
                              class="keywords">void</code> <code class="plain">main(String[] args)</code></div>
                          <div class="line number12 index11 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code></div>
                          <div class="line number13 index12 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">Demo d1 = </code><code class="keywords">new</code> <code
                              class="plain">Demo();</code></div>
                          <div class="line number14 index13 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="keywords">int</code><code class="plain">[] actualArray = &#123; </code><code
                              class="value">1</code><code class="plain">, </code><code class="value">2</code><code
                              class="plain">, </code><code class="value">3</code><code class="plain">, </code><code
                              class="value">4</code><code class="plain">, </code><code class="value">5</code> <code
                              class="plain">&#125;;</code></div>
                          <div class="line number15 index14 alt2">&nbsp;</div>
                          <div class="line number16 index15 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="keywords">for</code> <code class="plain">(</code><code class="keywords">int</code>
                            <code class="plain">items : actualArray)</code></div>
                          <div class="line number17 index16 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">System.out.print(items</code></div>
                          <div class="line number18 index17 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">+ </code><code class="string">" , "</code><code
                              class="plain">); </code><code class="comment">// printing array</code></div>
                          <div class="line number19 index18 alt2">&nbsp;</div>
                          <div class="line number20 index19 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">System.out.println();</code></div>
                          <div class="line number21 index20 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">d1.arrayUpdate(actualArray);</code></div>
                          <div class="line number22 index21 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">System.out.println();</code></div>
                          <div class="line number23 index22 alt2">&nbsp;</div>
                          <div class="line number24 index23 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="keywords">for</code> <code class="plain">(</code><code class="keywords">int</code>
                            <code class="plain">items : actualArray)</code></div>
                          <div class="line number25 index24 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">System.out.print(items</code></div>
                          <div class="line number26 index25 alt1"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                              class="plain">+ </code><code class="string">" , "</code><code
                              class="plain">); </code><code class="comment">// printing array</code></div>
                          <div class="line number27 index26 alt2"><code
                              class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code></div>
                          <div class="line number28 index27 alt1"><code class="plain">&#125;</code></div>
                        </div>
                      </td>
                    
              </div>
            </div>
           
          </div>
          
           
          </div>
        </div>
      
    <p>&nbsp;<br/>&nbsp;</p>
    <div class="output"><strong>Output</strong>
      <pre>1 , 2 , 3 , 4 , 5 ,  <br />
  
  1 , 2 , 99 , 4 , 77 , </pre>
    </div>
    <p>&nbsp;</p>
    <p ><strong>4.</strong> <strong>this and super keywordss are also Pointing
        Elements.</strong></p>
    <p>&nbsp;</p>
    <p >this keywords. In
      java, <strong>this</strong> is a reference variable that refers to the current object.</p>
    <p>&nbsp;</p>
    <p>
    </p>
    <p >super is used to refer
      immediate parent class instance variable. We can use the super keywords to access the data member or field of the
      parent class. It is used if parent class and child class have the same fields.</p>
    <p>&nbsp;</p>
    <p></p>
    <p ><strong>&nbsp;5. </strong><strong>null</strong><strong>
        value of a reference variable.</strong></p>
    <p>&nbsp;</p>
    <blockquote>
      <p ><strong>Demo obj = null ; &nbsp;</strong></p>
    </blockquote>
    <p ><strong>A.</strong> The <strong>null</strong> reference can be set as the value of any
      reference type variable.</p>
    <p>&nbsp;</p>
    <p ><strong>B.</strong> The object whose name is <strong>obj</strong> is referred to by
      nobody. In other words, the object has become <strong>garbage</strong>. In the Java programming language, the
      programmer need not worry about the program’s memory use. From time to time, the automatic garbage collector of
      the Java language cleans up the objects that have become garbage. If the garbage collection did not happen, the
      garbage objects would reserve a memory location until the end of the program execution.</p>
    <p>&nbsp;</p>
    <div class="noIdeBtnDiv">
      <div class="responsive-tabs-wrapper">
        <div class="responsive-tabs responsive-tabs--enabled">
         
          
          <div class="tabcontent responsive-tabs__panel responsive-tabs__panel--active" aria-hidden="false"
            role="tabpanel" aria-labelledby="tablist8-tab1" id="tablist8-panel1">
            <div class="code-block">
             
                
              <div class="code-containers">
                <div id="highlighter_990717" class="syntaxhighlighter nogutter">
                  
                        <td class="code">
                          <div class="containers">
                            <div class="line number1 index0 alt2"><code class="comment">// null in java</code></div>
                            <div class="line number2 index1 alt1">&nbsp;</div>
                            <div class="line number3 index2 alt2"><code class="keywords">import</code> <code
                                class="plain">java.io.*;</code></div>
                            <div class="line number4 index3 alt1"><code class="keywords">class</code> <code
                                class="plain">Demo &#123;</code></div>
                            <div class="line number5 index4 alt2"><code
                                class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">int</code>
                              <code class="plain">x = </code><code class="value">10</code><code class="plain">;</code>
                            </div>
                            <div class="line number6 index5 alt1"><code
                                class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="keywords">int</code>
                              <code class="plain">display()</code></div>
                            <div class="line number7 index6 alt2"><code
                                class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
                            </div>
                            <div class="line number8 index7 alt1"><code
                                class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                                class="plain">System.out.println(</code><code class="string">"x = "</code> <code
                                class="plain">+ x);</code></div>
                            <div class="line number9 index8 alt2"><code
                                class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                                class="keywords">return</code> <code class="value">0</code><code class="plain">;</code>
                            </div>
                            <div class="line number10 index9 alt1"><code
                                class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
                            </div>
                            <div class="line number11 index10 alt2"><code class="plain">&#125;</code></div>
                            <div class="line number12 index11 alt1"><code class="keywords">class</code> <code
                                class="plain">Main &#123;</code></div>
                            <div class="line number13 index12 alt2"><code
                                class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                                class="keywords">public</code> <code class="keywords">static</code> <code
                                class="keywords">void</code> <code class="plain">main(String[] args)</code></div>
                            <div class="line number14 index13 alt1"><code
                                class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
                            </div>
                            <div class="line number15 index14 alt2"><code
                                class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                                class="plain">Demo obj = </code><code class="keywords">null</code><code
                                class="plain">;</code></div>
                            <div class="line number16 index15 alt1">&nbsp;</div>
                            <div class="line number17 index16 alt2"><code
                                class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                                class="comment">// accessing instance(object) method</code></div>
                            <div class="line number18 index17 alt1"><code
                                class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                                class="plain">Kuchbhi.display();</code></div>
                            <div class="line number19 index18 alt2"><code
                                class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
                            </div>
                            <div class="line number20 index19 alt1"><code class="plain">&#125;</code></div>
                          </div>
                        </td>
                      
                </div>
              </div>
             
            </div>
          
            </div>
          </div>
        </div>
      </div>
    
    <p>&nbsp;<br/>&nbsp;</p>
    <p ><strong>Output</strong></p>
    <p>&nbsp;</p>
    <pre className='output'>Exception in thread "main" java.lang.NullPointerException <br />
  at Main.main(File.java:17) <br />
  Java Result: 1</pre>
    <p>&nbsp;</p>
    <p >Here, we try to access objects’ members by a reference variable which is pointing
      nothing(null), and hence it shows <strong>NullPointerException. </strong>Now if you get the error, the first step
      is to look for variables whose value could be null. Fortunately, the error message is useful: it tells which row
      caused the error. Just try it out yourself!</p>
    <p>&nbsp;</p>
   
  
</article>
        </div>
    )

                              }
export default Jva_ref
